module.exports = __webpack_public_path__ + "static/cx-design-banner-5496519c01db6b68fbe47e6ffdedffda.png";